const config = {
    debug: true,
	web_title: "A3 Mall",
    base_url: window.location.protocol + "//" + window.location.host + "/homeapi",
    request_timeout: 60000,
    version: "3.3.2"
}

if(process.env.NODE_ENV == "development"){
    config.base_url = 'http://yalongcn.com:8888/homeapi';
    // config.base_url = 'https://yalongcn.cn/homeapi';
}

export default config